import { Injectable } from '@angular/core';
import { DataSourceControlService } from './data-source-control.service';

@Injectable()
export class OptionTemplateService {

  readonly matTemplateTypeObs = this._dataSourceService.matTemplateTypeObs;
  readonly templateSubject = this._dataSourceService.templateSubject;
  readonly displayExprSubject = this._dataSourceService.displayExprSubject;

  constructor(
    private _dataSourceService: DataSourceControlService
  ) {

  }



}
